module.exports = __webpack_public_path__ + "static/media/poste_21.023670de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_21.jpg
// module id = 250
// module chunks = 0